/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Go_To_Event_StartInputs */

const en_shortcut_keys_name_go_to_event_start = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go To Start Of Event`)
};

const fr_shortcut_keys_name_go_to_event_start = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller au debut de l'evenement`)
};

const de_shortcut_keys_name_go_to_event_start = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehe zum Start des Ereignisses`)
};

const it_shortcut_keys_name_go_to_event_start = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai all'inizio dell'evento`)
};

const ru_shortcut_keys_name_go_to_event_start = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к началу мероприятия`)
};

const es_shortcut_keys_name_go_to_event_start = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al inicio del evento`)
};

const zh_cn2_shortcut_keys_name_go_to_event_start = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往活动开始处`)
};

const ja_shortcut_keys_name_go_to_event_start = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの開始へ移動`)
};

const hi_shortcut_keys_name_go_to_event_start = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट की शुरुआत पर जाएं`)
};

const pt_pt2_shortcut_keys_name_go_to_event_start = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o início do evento`)
};

/**
* | output |
* | --- |
* | "Go To Start Of Event" |
*
* @param {Shortcut_Keys_Name_Go_To_Event_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_go_to_event_start = /** @type {((inputs?: Shortcut_Keys_Name_Go_To_Event_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Go_To_Event_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_go_to_event_start(inputs)
	if (locale === "de") return de_shortcut_keys_name_go_to_event_start(inputs)
	if (locale === "it") return it_shortcut_keys_name_go_to_event_start(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_go_to_event_start(inputs)
	if (locale === "es") return es_shortcut_keys_name_go_to_event_start(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_go_to_event_start(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_go_to_event_start(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_go_to_event_start(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_go_to_event_start(inputs)
	return en_shortcut_keys_name_go_to_event_start(inputs)
});